import * as React from "react";
import Spinner from "../../hiberUiKit/src/atoms/Spinner/Spinner";

import "./appLoading.scss"

const spinner = require("./../../../resources/hiber/img/spinner-orange.png");
const logo = require("./../../../resources/hiber/img/dg-logo-big-green.png");

/**
 * Loading App view.
 */
export default class LoadingAppView extends React.PureComponent <{}, {}> {

	render() {
		return (
			<div className={"c-app-loading"}>
				<Spinner size={72} imgUrl={spinner} customClass={"c-app-loading_spinner"}/>
				<div style={{paddingTop: "40px"}}>
					<img src={logo}/>
				</div>
			</div>
		)
	}
}